module.exports = __webpack_public_path__ + "static/media/produits-menagers.ad911177.svg";